import { useGenericContext } from "../../hooks";
import { QueryParamsContext } from "./QueryParamsContext";

export const useQueryParams = () => useGenericContext(QueryParamsContext);
